/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
import {
  Avatar,
  AvatarGroup,
  Box,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { stringAvatar } from '../../../utils/avatarGenerator';
import { InfoCard } from '../../../components/InfoCard';
import { Board } from '../../../services/requests';

import {
  Card,
  Container,
  Div,
  MembersNumber,
  Page,
  SectionMembers,
  Title,
} from './styles';

dayjs().format();

interface BoardProps {
  boardArchives: Board[] | undefined;
  loading: boolean;
}

export const CardBoardArchived = ({ boardArchives, loading }: BoardProps) => {
  const navigate = useNavigate();

  const [listagemArchiveBoards, setListagemArchiveBoards] = useState<Board[]>(
    [],
  );

  useEffect(() => {
    if (boardArchives && boardArchives?.length > 0) {
      setListagemArchiveBoards(boardArchives);
    }
  }, [boardArchives]);

  if (loading) {
    <Container>
      <CircularProgress />
    </Container>;
  }

  return (
    <Div>
      {loading ? (
        <Page
          display="flex"
          paddingTop="250px"
          justifyContent="center"
          width="100%"
        >
          <CircularProgress />
        </Page>
      ) : boardArchives && boardArchives?.length > 0 ? (
        <Container className="Container">
          {listagemArchiveBoards.map(b => (
            <Card
              status={b.status}
              key={b.id}
              onClick={() => navigate(`board-details/${b.id}`)}
              sx={{ borderColor: b.color }}
            >
              <Box display="flex" width="100%">
                <Tooltip title={b.title} arrow>
                  <Title>{b.title}</Title>
                </Tooltip>
              </Box>
              <SectionMembers>
                <MembersNumber>
                  {b?.members && b?.members.length}{' '}
                  {b?.members && b?.members.length > 1
                    ? 'PARTICIPANTES'
                    : 'PARTICIPANTE'}
                </MembersNumber>
                <AvatarGroup max={5}>
                  {b?.members?.map(e => (
                    <Tooltip title={e.name} arrow>
                      {e?.avatar_url ? (
                        <Avatar
                          sx={{
                            width: '42px',
                            height: '42px',
                            borderColor: '#BDBDBD',
                          }}
                        >
                          <img
                            src={e?.avatar_url as string}
                            alt="Foto de perfil"
                            style={{ width: '100%' }}
                          />
                        </Avatar>
                      ) : (
                        <Avatar
                          {...stringAvatar(e.name!)}
                          sx={{
                            width: '42px',
                            height: '42px',
                            borderColor: '#BDBDBD',
                          }}
                        />
                      )}
                    </Tooltip>
                  ))}
                </AvatarGroup>
              </SectionMembers>
            </Card>
          ))}
        </Container>
      ) : (
        <Page
          display="flex"
          paddingTop="250px"
          justifyContent="center"
          width="100%"
        >
          <InfoCard
            title="No momento você não possui boards arquivados."
            type="info"
          />
        </Page>
      )}
    </Div>
  );
};
